import { useState } from "react";

import Topbar from "../../components/topbar";

type Props = {
  onFilter?: (value: boolean) => any;
};

const AnalyticsTopbar = ({ onFilter }: Props) => {
  const [activeBtnFilter, setactiveBtnFilter] = useState("Campaigns");

  const handleFilter = (selected: { label: string; value: string }) => {
    setactiveBtnFilter(selected.label);
    onFilter?.(selected.value === "campaigns" ? true : false);
  };

  const topbarFilters = [
    {
      type: "button",
      label: "Campaigns",
      value: "campaigns",
      onClick: (value: any) => handleFilter(value),
    },
    {
      type: "button",
      label: "Customers",
      value: "customers",
      onClick: (value: any) => handleFilter(value),
    },
  ];

  return (
    <Topbar
      title="Analytics"
      onSearch={() => {}}
      activeBtnFilter={activeBtnFilter}
      filters={topbarFilters}
    />
  );
};

export default AnalyticsTopbar;
